import { render, staticRenderFns } from "./WxpayPaySuccess.vue?vue&type=template&id=527c0ec9&scoped=true"
import script from "./WxpayPaySuccess.vue?vue&type=script&lang=js"
export * from "./WxpayPaySuccess.vue?vue&type=script&lang=js"
import style0 from "./WxpayPaySuccess.vue?vue&type=style&index=0&id=527c0ec9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c0ec9",
  null
  
)

export default component.exports